module.exports = __webpack_public_path__ + "static/media/ios-at.7e69206f.svg";